@if (!isEditingFormular) {
  <div>
    <div class="task-detail">
      <div class="task-detail-header">
        @if (!isEditMode && model) {
          <h2>
            <div style="margin: 1rem">
              {{ model.taskNoDisplay }} - {{ model.label }}
            </div>
          </h2>
        }
      </div>
      @if ({ val: loading$ | async }; as loading) {
        <div class="task-detail-content">
          @if (!model || loading.val) {
            <div style="font-size: 72px; margin-top: 50px">
              <app-spinner-overlay [visible]="true"></app-spinner-overlay>
            </div>
          }
          @if (model && !loading.val) {
            <div>
              <mat-toolbar class="text-center example-button-row">
                @if (isEditMode) {
                  <div class="text-center example-button-row">
                    <button
                      mat-raised-button
                      (click)="OnAcceptEditMode()"
                      id="taskDetailSaveButton"
                      [primary]="true"
                      [disabled]="!CanAcceptEditMode()"
                    >
                      <mat-icon>check</mat-icon>
                      <span class="button-label" i18n="@@busave">Save</span>
                    </button>
                    <button mat-raised-button id="taskDetailCancelButton" (click)="OnCancelEditMode()">
                      <mat-icon>close</mat-icon>
                      <span class="button-label" i18n="@@bucancel">Cancel</span>
                    </button>
                  </div>
                }
                @if (!isEditMode) {
                  <div
                    class="text-center example-button-row"
                    [overflow]="false"
                  >
                    <button
                      mat-raised-button
                      (click)="OnStartEditMode()"
                      id="taskDetailEditButton"
                      [primary]="true"
                      i18n-title="@@TaskDetail_TaskEdit_Title"
                      title="Edit task"
                      [disabled]="!CanStartEditMode()"
                    >
                      <mat-icon>edit</mat-icon>
                      <span
                        i18n="@@TaskDetail_TaskEdit"
                        style="padding-left: 10px"
                        >Edit</span
                      >
                    </button>
                    @if (CanOrderCreate()) {
                      <button
                        mat-raised-button
                        [matMenuTriggerFor]="dropdownMenu"
                        id="taskDetailOrderMenuButton"
                        [disabled]="model.beleg"
                        i18n-title="@@TaskDetail_OrderCreateOrSelect_Title"
                        title="Create an order for this task or select an existing one"
                      >
                        <mat-icon>receipt</mat-icon>
                        <span style="padding-left: 10px">Auftrag</span>
                      </button>
                    }
                    <mat-menu #dropdownMenu="matMenu" xPosition="after">
                      <button
                        mat-menu-item
                        (click)="SetUrlFragment('orderCreate')"
                        id="taskDetailOrderCreateButton"
                        i18n-title="@@TaskDetail_OrderCreateOrSelect_Title"
                        title="Create an order for this task or select an existing one"
                        style="padding-left: 10px"
                      >
                        <mat-icon>add</mat-icon>
                        <span
                          i18n="@@TaskDetail_OrderCreate"
                          style="padding-left: 8px; text-transform: uppercase"
                          >Create an order</span
                        >
                      </button>
                      @for (item of buOrderCreateItems; track item) {
                        <button
                          mat-menu-item
                          (click)="item.click('orderSelect')"
                          style="padding-left: 10px"
                        >
                          <mat-icon>search</mat-icon>
                          <span
                            style="padding-left: 8px; text-transform: uppercase"
                            >{{ item.text }}</span
                          >
                        </button>
                      }
                    </mat-menu>
                    <button
                      mat-raised-button
                      (click)="OnDelete()"
                      id="taskDetailDeleteButton"
                      [primary]="false"
                      i18n-title="@@TaskDetail_TaskDelete_Title"
                      [disabled]="!canDelete()"
                      title="Delete this task"
                    >
                      <mat-icon>delete</mat-icon>
                      <span
                        i18n="@@TaskDetail_TaskDelete"
                        style="padding-left: 10px"
                        >Delete</span
                      >
                    </button>
                  </div>
                }
              </mat-toolbar>
              @if (isEditMode) {
                <div style="margin-top: 15px" class="title-editable" [formGroup]="formChange">
                  <frm-text
                    id="taskDetailTitleInput"
                    i18n-label="Aufgabentitel@@TaskTitel"
                    label="Task Title"
                    formControlName="label"
                    [forceIsRequired]="true"
                  >
                  </frm-text>
                </div>
              }
              <br />
              <mat-accordion multi>
                <!-- Allgemein expanded = true  -->
                <!-- Achtung auf die Richtige Reihenfolge der ngModel Atribute achten, siehe dazu den beitrag auf github https://github.com/angular/angular/issues/11234  -->
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span
                        i18n="Allgemein@@taskDetailMatExpansionTitle_General"
                        >General</span
                      >
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <fieldset>
                      @if (!isEditMode) {
                        <div>
                          <div class="attribute-content">
                            <div class="attribute-panel">
                              <div class="attribute">
                                <div class="label">
                                  <span i18n="Kategorie@@TaskDetail_Category"
                                    >Category</span
                                  >:
                                </div>
                                <div class="value">
                                  @if (model?.category) {
                                    @if (model.category.archived) {
                                      <span
                                        i18n="@@TaskDetail_Category_Archived"
                                        style="margin-right: 5px"
                                        >[Archived]</span
                                      >
                                    }
                                    <span>{{ model?.category?.label }}</span>
                                  }
                                  @if (!model?.category) {
                                    <span>
                                      --
                                      <span
                                        i18n="@@TaskDetail_Category_Undefined"
                                        >Undefined</span
                                      >
                                      --
                                    </span>
                                  }
                                </div>
                              </div>
                              <div class="attribute">
                                <div class="label">
                                  <span i18n="@@TaskDetail_Status">Status</span
                                  >:
                                </div>
                                <div class="value">
                                  <span>{{ status }}</span>
                                </div>
                              </div>
                              @if (model.sammelNr) {
                                <div class="attribute">
                                  <div
                                    class="label"
                                    i18n="@@TaskDetail_SammelNr"
                                  >
                                    Collection-No.:
                                  </div>
                                  <div class="value">
                                    <span
                                      >{{ model.sammelNr }}
                                      @if (model.beleg) {
                                        / {{ model.beleg.auftragsNr }}
                                      }
                                    </span>
                                    <button
                                      mat-icon-button
                                      i18n-title="
                                        @@TaskDetail_SammelNr_Unassign"
                                      title="Remove"
                                      (click)="OnOrderUnassign()"
                                      style="
                                        width: 16px;
                                        height: 16px;
                                        margin-left: 5px;
                                        line-height: 16px;
                                      "
                                    >
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  </div>
                                </div>
                              }
                              <div class="attribute">
                                <div class="label">
                                  <span i18n="Anlage@@TaskDetailFacility"
                                    >Facility</span
                                  >:
                                </div>
                                <div class="value">
                                  <span>{{ anlageNrKomplett }}</span>
                                </div>
                              </div>
                              <div class="attribute">
                                <div class="label">
                                  <span i18n="@@TaskDetail_ClaimResource"
                                    >Is claimed by</span
                                  >:
                                  <mat-icon
                                    matTooltip="This setting defines the technician who actually performs the task."
                                    i18n-matTooltip="@@taskAssigneeTooltip"
                                    [matTooltipHideDelay]="tooltipHideDelay"
                                    aria-label="This setting defines the technician who actually performs the task."
                                    i18n-aria-label="@@taskAssigneeTooltip"
                                    role="img"
                                  >
                                    info
                                  </mat-icon>
                                </div>
                                <div class="value" style="margin-left: -0.7rem">
                                  @if (formChange) {
                                    <form [formGroup]="formChange">
                                      <frm-planung-resource-select
                                        id="select-inline-claimResourceID"
                                        #selectInlineClaimResourceID
                                        formControlName="claimResourceID"
                                        [onlyUsers]="true"
                                        label="&nbsp;"
                                      >
                                      </frm-planung-resource-select>
                                    </form>
                                  }
                                </div>
                              </div>
                              <div class="attribute">
                                <div class="label">
                                  <span i18n="Vorgesehen für@@MeantFor"
                                    >Assigned To</span
                                  >:
                                  <mat-icon
                                    matTooltip="This setting defines, which technician or group should take care of the task."
                                    i18n-matTooltip="@@taskMeantForTooltip"
                                    i18n-aria-label="@@taskMeantForAriaLabel"
                                    [matTooltipHideDelay]="tooltipHideDelay"
                                    aria-label="This setting defines, which technician or group should take care of the task."
                                    role="img"
                                  >
                                    info
                                  </mat-icon>
                                </div>
                                <div class="value">
                                  <span>
                                    {{ assignedToResource }}
                                  </span>
                                </div>
                              </div>
                              @if (!isSaasInstance) {
                                <div class="attribute">
                                  <div
                                    i18n="
                                      Soll-Arbeitszeit@@TaskDetailTargetWorkTime"
                                    class="label"
                                  >
                                    Target work time:
                                  </div>
                                  <div class="value">
                                    <span>
                                      {{ workTimePlanned }}
                                    </span>
                                  </div>
                                </div>
                              }
                            </div>
                            <div class="attribute-panel">
                              <div class="attribute">
                                <div class="label">
                                  <span
                                    i18n="
                                      @@PlanungAPI_TaskDetail_AppiontmentArrangement"
                                    >Appointment Arrangement</span
                                  >:
                                </div>
                                <div class="value">
                                  <span>{{
                                    enumService.appointmentArrangementToString(
                                      model?.appointmentArrangement
                                    )
                                  }}</span>
                                </div>
                              </div>
                              @if (!isSaasInstance) {
                                <div class="attribute">
                                  <div class="label">
                                    <span
                                      i18n="
                                        Termine
                                        aktiv@@TaskDetailAppiontmentAcitve"
                                    >
                                      Appointment active </span
                                    >:
                                  </div>
                                  <div class="value">
                                    <span>{{
                                      model?.dateRangesActive ? "Ja" : "Nein"
                                    }}</span>
                                  </div>
                                </div>
                              }
                              <div
                                [style.fontStyle]="
                                  model?.dateRangesActive ? 'regular' : 'italic'
                                "
                              >
                                @if (!isSaasInstance) {
                                  <div class="attribute">
                                    <div class="label">
                                      <span
                                        i18n="Zu erledigen in@@TaskDetailToDoIn"
                                        >To do in</span
                                      >:
                                    </div>
                                    <div class="value">
                                      <span>{{
                                        model?.dateRanges?.periodOfAction
                                      }}</span>
                                    </div>
                                  </div>
                                }
                                <div class="attribute">
                                  <div class="label">
                                    <span i18n="@@TaskDetailPlannedWeek"
                                      >Planned for calendar week</span
                                    >:
                                  </div>
                                  <div class="value">
                                    <span>{{
                                      model?.dateRanges?.plannedWeek
                                    }}</span>
                                  </div>
                                </div>
                                @if (!isSaasInstance) {
                                  <div class="attribute">
                                    <div class="label">
                                      <span
                                        i18n="
                                          Plantermin@@TaskDetailPlannedAppiontment"
                                        >Planned Appointment</span
                                      >:
                                    </div>
                                    <div class="value">
                                      <span>{{
                                        model.dateRanges?.todoDate | date
                                      }}</span>
                                    </div>
                                  </div>
                                }
                                <div class="attribute">
                                  <div class="label">
                                    <span i18n="@@TaskDetailPlannedTime"
                                      >Time of day</span
                                    >:
                                  </div>
                                  <div class="value">
                                    <span>{{
                                      model.dateRanges?.todoTime | date: "HH:mm"
                                    }}</span>
                                  </div>
                                </div>
                                <div class="attribute">
                                  <div class="label">
                                    <span i18n="@@TaskDetail_DueDate"
                                      >Due Date</span
                                    >:
                                  </div>
                                  <div class="value">
                                    <span>{{ model.dueDate | date }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                          @if (!isEditMode) {
                            <div style="padding: 20px; white-space: pre-wrap">
                              <span>{{ model.description }}</span>
                            </div>
                          }
                        </div>
                      }
                      @if (isEditMode) {
                        <div>
                          <div class="attribute-content">
                            <div class="attribute-panel">
                              @if (formChange) {
                                <form [formGroup]="formChange">
                                  <frm-planung-task-category-select
                                    id="taskDetailCategorySelect"
                                    formControlName="categoryID"
                                    i18n-label="
                                      @@PlanungAPI_TaskDetail_CategorySelect"
                                    label="Category Select"
                                    default="selectedItem"
                                  >
                                  </frm-planung-task-category-select>
                                  <app-task-status-droplist
                                    id="taskDetailStateSelect"
                                    i18n-label="@@TaskDetail_Status"
                                    label="Status"
                                    formControlName="state"
                                    [isMultiselect]="false"
                                    [forFilter]="false"
                                  >
                                  </app-task-status-droplist>
                                  <frm-planung-resource-select
                                    id="taskDetailClaimedBySelect"
                                    i18n-label="@@TaskDetail_ClaimResource"
                                    label="Is claimed by"
                                    formControlName="claimResourceID"
                                    [onlyUsers]="true"
                                  >
                                  </frm-planung-resource-select>
                                  <frm-planung-resource-select
                                    id="taskDetailAssignedToSelect"
                                    i18n-label="Vorgesehen für@@MeantFor"
                                    label="Assigned To"
                                    formControlName="assignedToResourceID"
                                    [onlyUsers]="false"
                                  >
                                  </frm-planung-resource-select>
                                </form>
                              }
                            </div>
                            <div class="attribute-panel">
                              @if (formChange) {
                                <form [formGroup]="formChange">
                                  <frm-appointment-arrangement-select
                                    id="taskDetailAppointmentArrangementSelect"
                                    i18n-label="
                                      @@PlanungAPI_TaskDetail_AppiontmentArrangement"
                                    label="Appointment Arrangement"
                                    formControlName="appointmentArrangement"
                                  >
                                  </frm-appointment-arrangement-select>
                                </form>
                              }
                              <!-- <section
                                style="padding-bottom: 22px; padding-top: 10px"
                              > -->
                              @if (!isSaasInstance) {
                                <frm-check
                                  id="taskDetailDateRangesActiveCheckbox"
                                  label="Appointment active"
                                  i18n-label="Termine aktiv@@appointmentactive"
                                  [(ngModel)]="changeModel.dateRangesActive"
                                >
                                </frm-check>
                              }

                              <!-- </section> -->
                              <div
                                [style.opacity]="
                                  changeModel.dateRangesActive ? 1 : 0.5
                                "
                              >
                                @if (!isSaasInstance) {
                                  <mat-form-field
                                    style="width: 150px; margin-right: 10px"
                                  >
                                    <mat-label>
                                      <span
                                        i18n="Zu erledigen in@@TaskDetailToDoIn"
                                        >To do in</span
                                      >
                                    </mat-label>
                                    <mat-select
                                      id="taskDetailPeriodMonthSelect"
                                      [(ngModel)]="
                                        changeModel.dateRanges.periodOfAction
                                          .month
                                      "
                                      name="month"
                                      (selectionChange)="
                                        OnYearPeriodInputChange(true)
                                      "
                                    >
                                      @for (month of Months; track month) {
                                        <mat-option [value]="month.value">
                                          <span>{{ month.name }}</span>
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                  <mat-form-field
                                    style="
                                      width: calc(100% - 160px);
                                      min-width: 55px;
                                    "
                                  >
                                    <input
                                      id="taskDetailPeriodYearInput"
                                      matInput
                                      class="example-right-align"
                                      type="number"
                                      min="1994"
                                      max="2099"
                                      [(ngModel)]="
                                        changeModel.dateRanges.periodOfAction
                                          .year
                                      "
                                      (change)="OnYearPeriodInputChange(true)"
                                    />
                                    <mat-hint align="end">
                                      1994 - 2099
                                    </mat-hint>
                                  </mat-form-field>
                                }
                                <div [formGroup]="formChange">
                                  <frm-text
                                    id="taskDetailCalendarWeekInput"
                                    i18n-label="
                                      @@PlanungAPI_TaskInsert_CalendarWeek_Label"
                                    label="Planned for CW"
                                    formControlName="rawCalendarWeek"
                                    mask="[0-5][0-9]/[0-9][0-9][0-9][0-9]"
                                    (valueChanged)="
                                      OnCalendarWeekInputChange(true)
                                    "
                                    i18n-placeholder="
                                      @@PlanungAPI_TaskInsert_CalendarWeek_Placeholder"
                                    placeholder="CW/YYYY"
                                    i18n-hint="
                                      @@PlanungAPI_TaskInsert_CalendarWeek_Hint"
                                    hint="eg. 19/2025, 43/2026, 51/2026"
                                    [validationMessages]="{
                                      pattern:
                                        validationMessageCalendarWeekPattern,
                                      invalidWeek:
                                        validationMessageCalendarWeekInvalid,
                                    }"
                                  >
                                  </frm-text>
                                </div>
                                <label style="width: 100%">
                                  @if (formChange) {
                                    <form [formGroup]="formChange">
                                      <!-- <div formGroupName="dateRanges"> -->
                                      @if (!isSaasInstance) {
                                        <frm-date-picker
                                          id="taskDetailTodoDateInput"
                                          formControlName="todoDate"
                                          i18n-label="
                                            Plantermin@@TaskDetailPlannedAppiontment"
                                          label="Planned Appointment"
                                          [showReset]="true"
                                          normalize="mid_of_day"
                                          (valueChanged)="
                                            OnTodoDateInputChange(true)
                                          "
                                        >
                                        </frm-date-picker>
                                      }
                                      <!-- </div> -->
                                      <frm-time-picker
                                        id="taskDetailTodoTimeInput"
                                        formControlName="todoTime"
                                        i18n-label="@@TaskDetailPlannedTime"
                                        label="Time of day"
                                      >
                                      </frm-time-picker>
                                      <frm-date-picker
                                        id="taskDetailDueDateInput"
                                        formControlName="dueDate"
                                        i18n-label="@@TaskDetail_DueDate"
                                        label="Due Date"
                                        normalize="mid_of_day"
                                        [showReset]="true"
                                      >
                                      </frm-date-picker>
                                    </form>
                                  }
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </fieldset>
                  </ng-template>
                </mat-expansion-panel>
                <!-- Stamm-Attribute expanded = true  -->
                @if (isEditMode) {
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <span
                          i18n="
                            Stamm-Attribute@@taskDetailMatExpansionTitle_Mainattribute"
                          >Main-Attributes</span
                        >
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      @if (formChange) {
                        <form [formGroup]="formChange">
                          <fieldset>
                            <div class="attribute-panel">
                              <frm-anlage-facility-no-select
                                id="taskDetailFacilitySelect"
                                formControlName="anlageNrIntern"
                                i18n-label="
                                  Anlage@@taskDetailMatExpansionLabel_Facility"
                                label="Facility:"
                                (facilitySelected)="
                                  _OnFacilityNoSelected($event)
                                "
                              >
                              </frm-anlage-facility-no-select>
                            </div>
                            @if (!isSaasInstance) {
                              <div class="attribute-panel">
                                <frm-time-picker
                                  id="taskDetailWorkTimePlannedInput"
                                  formControlName="workTimePlanned"
                                  i18n-label="@@TargetWorkTimePlusHaM"
                                  label="Target work time (hours : minutes)"
                                  mode="timeSpan"
                                >
                                </frm-time-picker>
                              </div>
                            }
                          </fieldset>
                          <fieldset>
                            <legend i18n="Beschreibung@@Description">
                              Description
                            </legend>
                            <div class="attribute-content">
                              <div class="attribute-panel" style="width: 100%">
                                <frm-text
                                  formControlName="description"
                                  [id]="description"
                                  multiline="true"
                                  resizeable="true"
                                  rows="7"
                                  maxlength="10000"
                                >
                                </frm-text>
                              </div>
                            </div>
                          </fieldset>
                          <fieldset formGroupName="workLocation">
                            <legend i18n="@@ActivityLocation">
                              Activity Location
                            </legend>
                            <div class="attribute-content">
                              <div class="attribute-panel">
                                <!-- <input matInput [(ngModel)]="changeModel.workLocation.name"> -->
                                <frm-text
                                  label="Location Label"
                                  i18n-label="@@worklocation_name"
                                  formControlName="name"
                                ></frm-text>
                                <div class="row">
                                  <div class="col-9">
                                    <frm-text
                                      label="Street"
                                      i18n-label="@@worklocation_street"
                                      formControlName="street"
                                    ></frm-text>
                                  </div>
                                  <div class="col-3">
                                    <frm-text
                                      label="Street No."
                                      i18n-label="@@worklocation_streetNo"
                                      formControlName="streetNo"
                                    ></frm-text>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-3">
                                    <frm-text
                                      label="Postal Code"
                                      i18n-label="@@worklocation_postalCode"
                                      formControlName="postalCode"
                                    ></frm-text>
                                  </div>
                                  <div class="col-9">
                                    <frm-text
                                      label="City"
                                      i18n-label="@@worklocation_city"
                                      formControlName="city"
                                    ></frm-text>
                                  </div>
                                </div>
                              </div>
                              @if (!isSaasInstance) {
                                <div class="attribute-panel">
                                  <frm-text
                                    label="Kilometres planned"
                                    i18n-label="
                                      @@worklocation_kilometresPlanned"
                                    formControlName="kilometresPlanned"
                                    type="number"
                                  ></frm-text>
                                  <div>
                                    <frm-time-picker
                                      formControlName="driveTimePlanned"
                                      mode="timeSpan"
                                      i18n-label="
                                        @@worklocation_driveTimePlannedUnits"
                                      label="Planned driving time (hours : minutes)"
                                    >
                                    </frm-time-picker>
                                  </div>
                                </div>
                              }
                            </div>
                          </fieldset>
                        </form>
                      }
                    </ng-template>
                  </mat-expansion-panel>
                }
                <!-- Tätigkeitsort expanded = true  -->
                @if (!isEditMode) {
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <span
                          i18n="
                            Tätigkeitsort@@taskDetailMatExpansionTitle_WorkLocation"
                          >Work Location</span
                        >
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <fieldset>
                        @if (!isEditMode) {
                          <div>
                            <div class="attribute-content">
                              <div class="attribute-panel">
                                <div class="attribute">
                                  <div class="label">
                                    <span i18n="StandortName@@worklocation_name"
                                      >Location Label</span
                                    >:
                                  </div>
                                  <div class="value">
                                    <span>{{ model.workLocation?.name }}</span>
                                  </div>
                                </div>
                                <div class="attribute">
                                  <div class="label">
                                    <span
                                      i18n="
                                        Strasse_HausNr@@worklocation_streetStreetNo"
                                      >Street / Street-No.:</span
                                    >
                                  </div>
                                  <div class="value">
                                    <span>
                                      {{ model.workLocation?.street }}
                                      {{ model.workLocation.streetNo }}
                                    </span>
                                  </div>
                                </div>
                                <div class="attribute">
                                  <div class="label">
                                    <span
                                      i18n="
                                        Postleitzahl_Ort@@worklocation_postalCodeCity"
                                      >Postal Code / City:</span
                                    >
                                  </div>
                                  <div class="value">
                                    <span>
                                      {{ model.workLocation?.postalCode }}
                                      {{ model.workLocation.city }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              @if (!isSaasInstance) {
                                <div class="attribute-panel">
                                  <div class="attribute">
                                    <div class="label">
                                      <span
                                        i18n="
                                          Gepl_Kilometer@@worklocation_kilometresPlanned"
                                        >Kilometres planned</span
                                      >:
                                    </div>
                                    <div class="value">
                                      <span>
                                        {{
                                          model.workLocation?.kilometresPlanned
                                        }}
                                        KM
                                      </span>
                                    </div>
                                  </div>
                                  <div class="attribute">
                                    <div class="label">
                                      <span
                                        i18n="
                                          Gepl_Fahrzeit@@worklocation_driveTimePlanned"
                                        >Planned driving time:</span
                                      >
                                    </div>
                                    <div class="value">
                                      <span>
                                        {{ driveTimePlanned }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </fieldset>
                    </ng-template>
                  </mat-expansion-panel>
                }
                <!-- Kommentar expanded = false  -->
                @if (isEditMode) {
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <span
                          i18n="Kommentar@@taskDetailMatExpansionTitle_Comment"
                          >comment</span
                        >
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <div class="attribute-content">
                        <div class="attribute-panel" style="width: 100%">
                          @if (formChange) {
                            <form [formGroup]="formChange">
                              <frm-text
                                formControlName="comment"
                                [id]="comment"
                                multiline="true"
                                resizeable="true"
                                rows="7"
                                maxlength="2000"
                              >
                              </frm-text>
                            </form>
                          }
                        </div>
                      </div>
                    </ng-template>
                  </mat-expansion-panel>
                }
                <!-- Push-Benachrichtigung expanded = false  -->
                @if (isEditMode && CanSendNotification()) {
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <span
                          i18n="
                            Push-Benachrichtigung@@taskDetailMatExpansionTitle_PushNotification"
                          >push notification</span
                        >
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <div class="row" style="margin: 10px">
                        <div class="col" style="margin-top: 15px">
                          <section style="width: 100%">
                            <mat-checkbox
                              class="m-checkbox"
                              id="sendPushNotification"
                              [(ngModel)]="changeModel.sendPushNotification"
                              i18n-title="
                                Sende eine Push-Benachrichtigung an den
                                zugewiesenen
                                Benutzer@@taskDetailMatExpansionTitle_SendNotification"
                              title="Send a push notification to the assigned user."
                            >
                              <span
                                i18n="
                                  Sende
                                  Push-Benachrichtigung@@taskDetailMatExpansionNotification"
                                >Send a push notification</span
                              >
                            </mat-checkbox>
                          </section>
                        </div>
                        @if (false) {
                          <div class="col">
                            <!-- #9652 vorerst auf HIDE setzen -->
                            <mat-form-field
                              style="padding-top: 15px; width: 100%"
                            >
                              <mat-label>
                                <span
                                  i18n="
                                    Benachrichtigungs-Kategorie@@taskDetailMatExpansionTitle_NotificationCategory"
                                  >Notifications-Category:</span
                                >
                              </mat-label>
                              <mat-select
                                [(ngModel)]="changeModel.pushNotificationTag"
                                name="category"
                              >
                                <mat-option value=""
                                  >-- Ohne Kategorie --</mat-option
                                >
                                <mat-option value="Wartung">Wartung</mat-option>
                                <mat-option value="Störung">Störung</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        }
                      </div>
                    </ng-template>
                  </mat-expansion-panel>
                }
                <!-- Sonstiges expanded = true  -->
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span i18n="Sonstiges@@taskDetailMatExpansionTitle_Other"
                        >other</span
                      >
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <cst-tab-sheet [animated]="false" [saveStateInQuery]="true">
                      <cst-tab i18n-title="@@comments" title="Comments">
                        @for (
                          activity of model.taskActivities;
                          track activity
                        ) {
                          <ng-container
                            [ngTemplateOutlet]="taskActivityTemplate"
                            [ngTemplateOutletContext]="{
                              $implicit: activity,
                              onlyComments: true,
                            }"
                          ></ng-container>
                        }
                      </cst-tab>
                      <cst-tab i18n-title="@@forms" title="Forms">
                        <app-task-formular-table
                          [taskID]="model.id"
                          (add)="OnTaskFormularCreate()"
                          (change)="OnTaskFormularChange($event)"
                          (delete)="OnTaskFormularDelete($event)"
                          (editFormular)="onEditFormular($event)"
                          [facilityID]="anlageID"
                        >
                        </app-task-formular-table>
                      </cst-tab>
                      <cst-tab i18n-title="@@changes" title="Changes">
                        @for (
                          activity of model.taskActivities;
                          track activity
                        ) {
                          <ng-container
                            [ngTemplateOutlet]="taskActivityTemplate"
                            [ngTemplateOutletContext]="{ $implicit: activity }"
                          ></ng-container>
                        }
                      </cst-tab>
                    </cst-tab-sheet>
                  </ng-template>
                </mat-expansion-panel>
              </mat-accordion>
              <br />
              @if (isEditMode && !loading.val) {
                <div class="text-center example-button-row">
                  <button
                    mat-raised-button
                    [primary]="true"
                    [disabled]="!CanAcceptEditMode()"
                    (click)="OnAcceptEditMode()"
                  >
                    <mat-icon>check</mat-icon>
                    <span class="button-label" i18n="@@busave">Save</span>
                  </button>
                  <button mat-raised-button (click)="OnCancelEditMode()">
                    <mat-icon>close</mat-icon>
                    <span class="button-label" i18n="@@bucancel">Cancel</span>
                  </button>
                </div>
              }
              @if (!isEditMode) {
                <div class="text-center example-button-row">
                  <button
                    mat-raised-button
                    (click)="OnGoBack()"
                    style="padding: 0px 16px 0px 7px"
                  >
                    <mat-icon>chevron_left</mat-icon>
                    <span i18n="@@Button_Back">Go Back</span>
                  </button>
                </div>
              }
              <br />
            </div>
          }
        </div>
      }
      <div class="task-detail-sidebar">
        <app-planung-task-detail-sidebar
          [task]="model"
        ></app-planung-task-detail-sidebar>
      </div>
    </div>
    <ng-template
      #taskActivityTemplate
      let-activity
      let-onlyComments="onlyComments"
    >
      @if (!onlyComments || (onlyComments && activity.comment)) {
        <div style="margin: 10px">
          <span class="small"
            ><b>{{ GetUserNameForTaskActivity(activity) }}</b> -
            {{
              activity.changeDateTime
                | date: "EEEE, d. MMMM, y 'um' HH:mm 'Uhr'"
            }}</span
          >
          @if (activity.comment) {
            <div
              style="
                margin: 10px;
                border-color: silver;
                border-style: solid;
                border-radius: 2px;
                border-width: 1px;
                padding: 20px;
                white-space: pre-wrap;
              "
            >
              <span>{{ activity.comment }}</span>
            </div>
          }
          @if (!onlyComments) {
            <ul class="small" style="font-size: 75%">
              @for (change of activity.changes; track change) {
                @if (change?.displayName && !change.isConflicted) {
                  <li i18n="@@taskActivityChangeEntry">
                    <b>"{{ change?.displayName }}"</b> changed from
                    <b>"{{ change?.oldValue }}"</b> to
                    <b>"{{ change?.newValue }}"</b>
                  </li>
                }
                @if (change?.displayName && change.isConflicted) {
                  <li
                    i18n="@@taskActivityChangeEntryConflicted"
                    style="color: red"
                  >
                    <b>"{{ change?.displayName }}"</b> with value
                    <b>"{{ change?.oldValue }}"</b> was tried to change to "{{
                      change?.intendedValue
                    }}"; change was cancelled because the value in the database
                    was newer than the intended change.
                  </li>
                }
                @if (change?.text) {
                  <li>
                    {{ change.text }}
                  </li>
                }
              }
            </ul>
          }
        </div>
      }
    </ng-template>
  </div>
}

@if (isEditingFormular && (loading$ | async) === false) {
  <app-formular-editor
    [editedFormularId]="editedFormularId"
    (close)="onFormularEditorClose()"
  >
  </app-formular-editor>
}
